export enum FieldsEnum {
  BOOL = 'bool',
  INPUT = 'input',
  URL = 'url',
  PHONE = 'phone',
  EMAIL = 'email',
  ENUM = 'enum',
  SLIDER = 'slider',
  STARS = 'stars',
  ZIP = 'zip',
  SSN = 'ssn',
  DATE = 'date',
  MULTILINE_INPUT = 'multilineinput',
  SINGLE_FILE_INPUT = 'singlefileinput',
  MULTI_FILE_INPUT = 'multifileinput'
}
